import MainLayout from "@/components/layout/admin/MainLayout.vue";
import axios from "axios";
import CONFIG from "@/assets/js/config.js";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
  name: "campusDetail",
  components: {
    MainLayout,
    Loading
  },

  data() {
    return {
      isLoading: false,
      campusData: [],
      noDataMsg: CONFIG.NO_DATA_EXIST,
    };
  },

  methods: {
    getDetail() {
      axios.get(`campus/detail/${this.$route.params.id}`)
        .then(res => {
          if (res.data) {
            this.campusData = res.data;
          }
          this.isLoading = false;
        })
        .catch(error => {
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
          console.log("Campus Detail API Error", error);
        })
    },
  },

  mounted() {
    this.isLoading = true;
    this.getDetail();
  },
};
